import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import type User from 'modules/core/store/models/User'

import { RevieweesContext } from 'modules/reviews/lib/RevieweesContext'

import Table from './Table'

interface ContentProps {
  user: User
}

export default function Content({ user }: ContentProps) {
  const { loading, reviewees } = React.useContext(RevieweesContext)
  const reviewers = reviewees[user.attributes.id] || []

  return <Box gap="s32">{loading ? <Loading /> : <Table reviewers={reviewers} />}</Box>
}
